// QuoteDrawer's writes (finance-real, the user 2026-10-22): Add a job at its list puts a draft job on the quote, and each
// job's status dropdown on its list sets that job's (DD-062). Its own status picker has its own hook (useStatusPicker).
import type { UseMutationResult } from "@tanstack/react-query";
import { useSetJobStatus, useUpdateQuote } from "../../hooks/useLineJobs";
import type { LineJob, LineJobStatusInput, QuoteBundle, QuoteInput } from "../../types";

export interface QuoteDrawerModel {
  update: UseMutationResult<QuoteBundle, Error, { quoteId: string; input: Partial<QuoteInput> }>;
  setJobStatus: UseMutationResult<LineJob, Error, { jobId: string; input: LineJobStatusInput }>;
}

export function useQuoteDrawer(): QuoteDrawerModel {
  return { update: useUpdateQuote(), setJobStatus: useSetJobStatus() };
}
